import { render, staticRenderFns } from "./ApprovalFormsCate.vue?vue&type=template&id=21f0b76c&scoped=true&"
import script from "./ApprovalFormsCate.vue?vue&type=script&lang=js&"
export * from "./ApprovalFormsCate.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalFormsCate.vue?vue&type=style&index=0&id=21f0b76c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f0b76c",
  null
  
)

export default component.exports